import { apiRoutes } from '../../api-routes';
import { epApiUrl } from '../../constants';
import { type AxiosRequestConfig, httpClient } from '../../util';
import type { GeocodeReverseData } from './types';
import { formatFeatureToAddress } from './utils';

export type GeocodeReverseParams = {
  lng: number;
  lat: number;
  profile?: string;
  'boundary.country'?: string;
  'boundary.circle.radius'?: string;
};

export const getGeocodeReverseFn = async (
  params: GeocodeReverseParams,
  config: AxiosRequestConfig = {}
) => {
  const response = await httpClient.get<GeocodeReverseData>(
    epApiUrl + apiRoutes.place.geocode_reverse,
    {
      params: {
        profile: 'ahamove',
        'boundary.country': 'VN',
        'boundary.circle.radius': '2000',
        ...params,
      },
      ...config,
    }
  );
  return formatFeatureToAddress(response.data.data);
};
